import { useState } from "react";

import styled from "styled-components";

import FnrTypography from "FnrTypography";
import { AnimatePresence, motion } from "framer-motion";

import FnrWarningBox from "UI/FnrWarningBox";
import { explode, inOutMotion } from "UI/motionStyles";

import { use2FAState } from "../../API/queryHooks";

const SFnrWarningBox = styled(FnrWarningBox)`
  margin-top: 16px;
`;

const HelpMessage = () => {
  const [{ message }] = use2FAState();

  const [explodeIt] = useState(0.1 > Math.random());

  return (
    <AnimatePresence>
      {Boolean(message) && (
        <motion.div
          {...(explodeIt ? explode : inOutMotion)}
          exit={inOutMotion.exit}
        >
          <SFnrWarningBox data-cy="TwoFA_HelpMessage">
            <FnrTypography color="textWarning">{message}</FnrTypography>
          </SFnrWarningBox>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HelpMessage;
